import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  CollectionUploadStatus,
  UploadCollectionController,
} from 'src/app/shared/services/download-manager-service';

@Component({
  selector: 'app-upload-collection',
  templateUrl: './upload-collection.component.html',
  styleUrl: './upload-collection.component.scss',
})
export class UploadCollectionComponent implements OnInit, OnDestroy {
  @Input() collection: UploadCollectionController;

  private collectionSubscription: Subscription;
  public currFileProgress = 0;
  public STATE = CollectionUploadStatus;
  public expandWarningBox = false;

  constructor() {}

  ngOnInit(): void {
    this.collectionSubscription = this.collection.subject.subscribe((value) => {
      this.currFileProgress = value.progress;
    });
  }

  ngOnDestroy(): void {
    this.collectionSubscription?.unsubscribe();
  }

  public pause() {
    this.collection.pause();
  }

  public resume() {
    this.collection.resume();
  }

  public delete() {
    this.collection.clear();
  }
}
